import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/r-project': {
    width: 581,
    height: 512,
    paths: [
      {
        d: 'M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480H338.5V418.5C362.8 415.8 386.1 411.1 407.9 404.6L448 480H560L492.6 366.3C547.1 330.9 581 281.4 581 226.6zM114.2 241.1C114.2 167.6 213.1 108.1 335 108.1S546.9 148.8 546.9 241.1C546.9 291.2 520.4 326.1 476.6 347.5 474.2 345.9 471.9 344.6 470.2 343.8 460 338.6 442.4 333.3 442.4 333.3S529 326.9 529 240.6 438.4 152.7 438.4 152.7H239.4V361C165.3 339.5 114.2 293.9 114.2 241.1zM339.3 279.4V223.8C397.1 223.8 427.1 217 427.1 251.1 427.1 287.6 388.9 279.4 339.3 279.4zM338.4 351.9H365C375.8 351.9 383.9 363.6 389 371.1 372.9 373 356 373.9 338.4 374V351.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/r-project.js
// module id = 9O9a
// module chunks = 144